import { createContext } from "react";
import { TypeOpcoesDoUsuario } from "../Models/OpcoesDoUsuario";

export type TypeOpcoesDoUsuarioContext = {
  opcoesDoUsuario: TypeOpcoesDoUsuario | null;
  setOpcoesDoUsuario: React.Dispatch<React.SetStateAction<TypeOpcoesDoUsuario | null>>;
}

export const OpcoesDoUsuarioContext = createContext<TypeOpcoesDoUsuarioContext | null>(null);